module.exports = __webpack_public_path__ + "img/import.7c896f1d.png";